import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "tip" }
const _hoisted_2 = { class: "tip" }
const _hoisted_3 = { class: "work-time-range" }
const _hoisted_4 = { class: "start" }
const _hoisted_5 = { class: "end" }

import { ref, computed } from 'vue'
import { cloneDeep } from 'lodash'
import {
    CalculateTypeDataset,
    CalculateTypeEnum,
    HalfUnitDataset,
    HalfUnitEnum,
    PriceTypeDataset,
    PriceTypeEnum,
    RoundTypeDataset,
    RoundTypeEnum,
    ShiftTypeEnum,
    WorkHourLimitTypeEnum,
    WorkNextDayDataset,
    WorkNextDayEnum
} from './attendance'
import dayjs from 'dayjs'
import { ElMessage } from 'element-plus'


export default /*@__PURE__*/_defineComponent({
  __name: 'calc-rule',
  props: {
    title: { default: '算工时规则' }
  },
  emits: ["submit"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

// eslint-disable-next-line func-call-spacing
const emits = __emit

const getFormDefaultData = () => {
    return {
        dateRange: [],
        facilityId: '',
        serveCompanyId: '',
        shiftType: ShiftTypeEnum.DayShift as typeof ShiftTypeEnum.valueType,
        priceType: PriceTypeEnum.PerHour,
        workHourLimitType: WorkHourLimitTypeEnum.Integer,
        calculateType: CalculateTypeEnum.PerWorkHour,
        roundType: RoundTypeEnum.Flexible,
        workNextDay: WorkNextDayEnum.No,
        halfUnit: HalfUnitEnum.Half,
        workHourLimit: 9,
        workHourLimitReduce: 1,
        price: '',
        thresholdMinutes: 40,
        toWorkTime: '',
        offWorkTime: ''
    }
}

const onValidateWorkHourLimit = (rule: any, value: any, callback: any) => {
    if (formData.value.workHourLimitType === WorkHourLimitTypeEnum.Integer && !formData.value.workHourLimit) {
        callback(new Error('请输入工时上限'))
        return
    }
    callback()
}

const onValidateWorkHourLimitReduce = (rule: any, value: any, callback: any) => {
    if (formData.value.workHourLimitType === WorkHourLimitTypeEnum.Subtract && !formData.value.workHourLimit) {
        callback(new Error('请输入工时上限'))
        return
    }
    if (formData.value.workHourLimitType === WorkHourLimitTypeEnum.Subtract && !formData.value.workHourLimitReduce) {
        callback(new Error('请输入工时减少值'))
        return
    }
    callback()
}

const onValidatePrice = (rule: any, value: any, callback: any) => {
    if (!formData.value.price) {
        callback(new Error(`请输入${formData.value.priceType === PriceTypeEnum.PerHour ? '时薪' : '日薪'}`))
        return
    }
    callback()
}

const onValidateWorkTime = (rule: any, value: any, callback: any) => {
    if (!formData.value.toWorkTime || !formData.value.offWorkTime) {
        callback(new Error('请选择上下班时间'))
        return
    }
    if (formData.value.toWorkTime && formData.value.offWorkTime) {
        const startDate = dayjs(`2000-01-01 ${formData.value.toWorkTime}:00`)
        let endDate = dayjs(`2000-01-01 ${formData.value.offWorkTime}:00`)
        if (formData.value.workNextDay === WorkNextDayEnum.Yes) {
            endDate = endDate.add(1, 'day')
        }
        if (endDate.isBefore(startDate)) {
            callback(new Error('下班时间应晚于上班时间'))
            return
        }
        if (endDate.diff(startDate, 'minutes') > 24 * 60) {
            callback(new Error('单次上下班间隔时间不能超过24小时'))
            return
        }
    }
    callback()
}

const visible = ref(false) as any
const formRef = ref() as any
const formData = ref(getFormDefaultData())
const formRule = ref({
    shiftType: [
        { required: true, message: '请选择班次规则', trigger: 'change' }
    ],
    dateRange: [
        { required: true, message: '请选择算薪起始日期', trigger: 'change' }
    ],
    priceType: [
        { required: true, message: '请选择计价方式', trigger: 'change' }
    ],
    workHourLimitType: [
        { required: true, message: '请选择工时限制类型', trigger: 'change' }
    ],
    calculateType: [
        { required: true, message: '请选择计算方式', trigger: 'change' }
    ],
    roundType: [
        { required: true, message: '请选择取整方式', trigger: 'change' }
    ],
    workHourLimit: [
        { validator: onValidateWorkHourLimit, trigger: 'blur' }
    ],
    workHourLimitReduce: [
        { validator: onValidateWorkHourLimitReduce, trigger: 'blur' }
    ],
    price: [
        { validator: onValidatePrice, trigger: 'blur' }
    ],
    thresholdMinutes: [
        { required: true, message: '请输入折算时间点', trigger: 'blur' }
    ],
    halfUnit: [
        { required: true, message: '请选择折算单位', trigger: 'change' }
    ],
    toWorkTime: [
        { validator: onValidateWorkTime, trigger: ['blur', 'change'] }
    ]
})

const calculateTypeOptions = ref(cloneDeep(CalculateTypeDataset))

const calculateTypeTip = computed(() => {
    return CalculateTypeDataset.find((item) => item.value === formData.value.calculateType)?.tip || ''
})

const roundTypeTip = computed(() => {
    return RoundTypeDataset.find((item) => item.value === formData.value.roundType)?.tip || ''
})

const onOpen = (presetParams) => {
    if (presetParams) {
        formData.value = {
            ...getFormDefaultData(),
            ...presetParams,
            dateRange: presetParams.startDate ? [presetParams.startDate, presetParams.endDate] : []
        }
    }
    // eslint-disable-next-line no-unused-expressions
    formRef.value?.clearValidate()
    visible.value = true
}

const onAfterClose = () => {
    console.log('onAfterClose')
    formData.value = getFormDefaultData()
    // eslint-disable-next-line no-unused-expressions
    formRef.value?.clearValidate()
    // eslint-disable-next-line no-unused-expressions
}

const onClose = () => {
    visible.value = false
}

const onSubmit = async () => {
    await formRef.value?.validate()
    emits('submit', cloneDeep(formData.value))
    onClose()
}

const onChangeDateRange = (value: [string, string] | null) => {
    if (value && value[0] && value[1]) {
        const start = dayjs(value[0])
        const end = dayjs(value[1])
        const diffDays = end.diff(start, 'day')

        if (diffDays > 62) {
            ElMessage.warning('时间范围不能超过2个月')
            return
        }
    }

    formData.value.dateRange = value || []
}

const onChangeWorkHourLimitType = () => {
    // eslint-disable-next-line no-unused-expressions
    formRef.value?.clearValidate(['workHourLimit', 'workHourLimitReduce'])
}

const onChangeWorkNextDay = () => {
    if (formData.value.workNextDay === WorkNextDayEnum.Yes) {
        formData.value.shiftType = ShiftTypeEnum.NightShift
        triggerDisabledPerWorkHourCalc()
    }
}

const triggerDisabledPerWorkHourCalc = () => {
    const disabled = formData.value.shiftType === ShiftTypeEnum.NightShift || formData.value.priceType === PriceTypeEnum.FixedAmount
    formData.value.calculateType = disabled ? CalculateTypeEnum.PerWorkTime : CalculateTypeEnum.PerWorkHour
    calculateTypeOptions.value.find((item) => item.value === CalculateTypeEnum.PerWorkHour).disabled = disabled
}

__expose({
    open: onOpen,
    close: onClose
})


return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((visible).value = $event)),
    title: _ctx.title,
    width: "850px",
    onClosed: onAfterClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, { onClick: onClose }, {
        default: _withCtx(() => _cache[29] || (_cache[29] = [
          _createTextVNode("取消")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: onSubmit
      }, {
        default: _withCtx(() => _cache[30] || (_cache[30] = [
          _createTextVNode("确定")
        ])),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: formData.value,
        rules: formRule.value,
        "label-width": "8em",
        "label-position": "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "班次规则",
            prop: "shiftType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: formData.value.shiftType,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.shiftType) = $event)),
                onChange: triggerDisabledPerWorkHourCalc
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ShiftTypeEnum).toSelect(), (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio_button, {
                      key: item.value,
                      label: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "算薪起始日期",
            prop: "dateRange"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                class: "date-picker",
                modelValue: formData.value.dateRange,
                "onUpdate:modelValue": onChangeDateRange,
                type: "daterange",
                "range-separator": "-",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
                "value-format": "YYYY-MM-DD",
                clearable: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "工价",
            prop: "priceType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: formData.value.priceType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.priceType) = $event)),
                onChange: triggerDisabledPerWorkHourCalc
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PriceTypeDataset), (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio_button, {
                      key: item.value,
                      label: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (formData.value.priceType === _unref(PriceTypeEnum).PerHour)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_el_space, {
                  direction: "vertical",
                  alignment: "flex-start"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: formData.value.workHourLimitType,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.workHourLimitType) = $event)),
                      onChange: onChangeWorkHourLimitType
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, { prop: "workHourLimit" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, {
                              label: _unref(WorkHourLimitTypeEnum).Integer
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_space, null, {
                                  default: _withCtx(() => [
                                    _cache[16] || (_cache[16] = _createElementVNode("div", null, "工时上限", -1)),
                                    _createVNode(_component_el_input_number, {
                                      modelValue: formData.value.workHourLimit,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.workHourLimit) = $event)),
                                      placeholder: ""
                                    }, null, 8, ["modelValue"]),
                                    _cache[17] || (_cache[17] = _createElementVNode("div", null, "小时", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { prop: "workHourLimitReduce" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio, {
                              label: _unref(WorkHourLimitTypeEnum).Subtract
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_space, null, {
                                  default: _withCtx(() => [
                                    _cache[18] || (_cache[18] = _createElementVNode("div", null, "工时上限", -1)),
                                    _createVNode(_component_el_input_number, {
                                      modelValue: formData.value.workHourLimit,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.workHourLimit) = $event)),
                                      placeholder: "",
                                      min: 0
                                    }, null, 8, ["modelValue"]),
                                    _cache[19] || (_cache[19] = _createElementVNode("div", null, "小时，减", -1)),
                                    _createVNode(_component_el_input_number, {
                                      modelValue: formData.value.workHourLimitReduce,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.workHourLimitReduce) = $event)),
                                      max: formData.value.workHourLimit,
                                      placeholder: "",
                                      min: 0
                                    }, null, 8, ["modelValue", "max"]),
                                    _cache[20] || (_cache[20] = _createElementVNode("div", null, "小时", -1))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "",
                  prop: "price"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formData.value.price,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.price) = $event)),
                          placeholder: "请输入时薪",
                          min: 0
                        }, null, 8, ["modelValue"]),
                        _cache[21] || (_cache[21] = _createElementVNode("span", null, "元/小时", -1))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ], 64))
            : _createCommentVNode("", true),
          (formData.value.priceType === _unref(PriceTypeEnum).FixedAmount)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 1,
                label: "",
                prop: "price"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: formData.value.price,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.price) = $event)),
                        placeholder: "请输入日薪",
                        min: 0
                      }, null, 8, ["modelValue"]),
                      _cache[22] || (_cache[22] = _createElementVNode("span", null, "元", -1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, {
            label: "计算方式",
            prop: "calculateType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: formData.value.calculateType,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.calculateType) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calculateTypeOptions.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_radio_button, {
                      key: item.value,
                      disabled: item.disabled,
                      label: item.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["disabled", "label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, _toDisplayString(calculateTypeTip.value), 1)
            ]),
            _: 1
          }),
          (formData.value.calculateType === _unref(CalculateTypeEnum).PerWorkHour)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createVNode(_component_el_form_item, {
                  label: "取整方式",
                  prop: "roundType"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: formData.value.roundType,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.roundType) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RoundTypeDataset), (item) => {
                          return (_openBlock(), _createBlock(_component_el_radio_button, {
                            key: item.value,
                            label: item.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(roundTypeTip.value), 1)
                  ]),
                  _: 1
                }),
                (formData.value.roundType === _unref(RoundTypeEnum).Flexible)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_form_item, { prop: "thresholdMinutes" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_space, null, {
                            default: _withCtx(() => [
                              _cache[23] || (_cache[23] = _createElementVNode("div", null, "工作时长满", -1)),
                              _createVNode(_component_el_input_number, {
                                modelValue: formData.value.thresholdMinutes,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.thresholdMinutes) = $event)),
                                placeholder: "",
                                max: 60,
                                min: 0
                              }, null, 8, ["modelValue"]),
                              _cache[24] || (_cache[24] = _createElementVNode("div", null, "分钟时，算 1 小时", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, { prop: "halfUnit" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_space, null, {
                            default: _withCtx(() => [
                              _cache[25] || (_cache[25] = _createElementVNode("div", null, "工作时长未满", -1)),
                              _createVNode(_component_el_input, {
                                modelValue: formData.value.thresholdMinutes,
                                disabled: ""
                              }, null, 8, ["modelValue"]),
                              _cache[26] || (_cache[26] = _createElementVNode("div", null, "分钟时，算", -1)),
                              _createVNode(_component_el_select, {
                                modelValue: formData.value.halfUnit,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.halfUnit) = $event))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HalfUnitDataset), (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _cache[27] || (_cache[27] = _createElementVNode("div", null, "小时", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (formData.value.calculateType === _unref(CalculateTypeEnum).PerWorkTime)
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 3,
                label: "上下班时间",
                prop: "toWorkTime"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_el_time_picker, {
                        modelValue: formData.value.toWorkTime,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.toWorkTime) = $event)),
                        placeholder: "上班时间",
                        format: "HH:mm",
                        "value-format": "HH:mm",
                        clearable: false
                      }, null, 8, ["modelValue"])
                    ]),
                    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "separator" }, "-", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_el_time_picker, {
                        modelValue: formData.value.offWorkTime,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.offWorkTime) = $event)),
                        placeholder: "下班时间",
                        format: "HH:mm",
                        "value-format": "HH:mm",
                        clearable: false,
                        "prefix-icon": "none"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_el_select, {
                        modelValue: formData.value.workNextDay,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.workNextDay) = $event)),
                        onChange: onChangeWorkNextDay
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WorkNextDayDataset), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              label: item.label,
                              value: item.value
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})